import axios from 'axios';

interface Idp {
  id: string;
  name: string;
  url?: string;
}
interface IdpDataRes {
  name: string;
  idps: Array<Idp>;
  usePassword?: boolean;
}

export const getIdpsOptions = async (email: string) =>
  axios.get<IdpDataRes>(`${process.env.AUTH_SERVER}/user/idps`, {
    params: { email },
  });
